module.exports = __webpack_public_path__ + "img/icon-btn-facebook2.3056a147.png";